import React from "react";
import * as MUIColors from "@mui/material/colors";
import * as MUIIcons from "@mui/icons-material";
import MUIAvatar from "@mui/material/Avatar";
import MUIGreyColor from "@mui/material/colors/grey";
import MUICheckCircleIcon from "@mui/icons-material/CheckCircle";
import OrderStatusReasonDetail from "../../Utility/Crud/OrderStatusReasonDetail";

import Chip from "../Chip";
import MainContext from "../../Context/MainContext/MainContext";

export default class ChipQueueOrderStatusReasonDetail extends Chip {
  static contextType = MainContext;

  renderAvatar() {
    // If selected, show white checkmark in a circle, else original avatar
    if (this.props.selected) {
      return (
        <MUIAvatar sx={{ bgcolor: "transparent" }}>
          <MUICheckCircleIcon
            fontSize="small"
            sx={{ color: (theme) => theme.palette.background.paper }}
          />
        </MUIAvatar>
      );
    } else {
      const orderStatusReason =
        this.context.orderStatusReasonsIndexed?.[
          this.props.orderStatusReasonDetail?.orderStatusReasonId
        ];
      const orderStatusId = orderStatusReason?.orderStatus;

      const orderStatus =
        orderStatusId !== null
          ? this.context.orderStatusesIndexed?.[orderStatusId]
          : null;
      const colorObject = orderStatus?.colorId
        ? this.context.colorsIndexed?.[orderStatus.colorId]
        : null;
      const color = colorObject
        ? MUIColors[colorObject.hue][colorObject.shade]
        : MUIGreyColor[500];
      const avatarColor = this.props.isTransparent ? "transparent" : color;
      const iconColor = this.props.isTransparent ? color : "#fff";

      const IconComponent = MUIIcons[OrderStatusReasonDetail.getIconName()];

      return (
        <MUIAvatar sx={{ bgcolor: avatarColor }}>
          {React.createElement(IconComponent, {
            fontSize: "small",
            sx: { color: iconColor },
          })}
        </MUIAvatar>
      );
    }
  }

  getLabel() {
    return this.props.label;
  }
}
